/**
 * Map a filename's extension to a Shiki language identifier used for syntax
 * highlighting. Extracted from the legacy CodeViewer so file-viewer behavior
 * stays unchanged after the RichCodeBlock pivot.
 */
const LANGUAGE_MAP = {
  js: 'javascript', jsx: 'jsx', ts: 'typescript', tsx: 'tsx',
  py: 'python', java: 'java', cpp: 'cpp', c: 'c', h: 'c',
  cs: 'csharp', php: 'php', rb: 'ruby', go: 'go', rs: 'rust',
  kt: 'kotlin', swift: 'swift',
  css: 'css', scss: 'scss', sass: 'sass', less: 'less',
  html: 'html', htm: 'html', xml: 'xml',
  json: 'json', yaml: 'yaml', yml: 'yaml', toml: 'toml',
  sql: 'sql',
  sh: 'bash', bash: 'bash', zsh: 'bash', fish: 'bash',
  ps1: 'powershell',
  dockerfile: 'docker', makefile: 'makefile', cmake: 'cmake',
  nginx: 'nginx', conf: 'nginx',
  ini: 'ini', cfg: 'ini',
  md: 'markdown', markdown: 'markdown',
  csv: 'csv', tsv: 'tsv',
  r: 'r', R: 'r',
  scala: 'scala', gradle: 'gradle', groovy: 'groovy',
  lua: 'lua', dart: 'dart', vue: 'vue', svelte: 'svelte',
  elm: 'elm', clj: 'clojure', cljs: 'clojure', hs: 'haskell',
  ml: 'ocaml', fs: 'fsharp', ex: 'elixir', exs: 'elixir',
  tf: 'hcl', hcl: 'hcl',
  proto: 'protobuf', graphql: 'graphql', gql: 'graphql',
  sol: 'solidity', vim: 'vim',
  tex: 'latex', latex: 'latex',
  diff: 'diff', patch: 'diff',
};

export const getLanguageFromFilename = (filename = '') => {
  const ext = filename.split('.').pop().toLowerCase();
  return LANGUAGE_MAP[ext] || 'text';
};
